import React, { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';
interface CounterProps {
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}

/** Counts up to a value once it scrolls into view. */
export function Counter({
  value,
  prefix = '',
  suffix = '',
  decimals = 0
}: CounterProps) {
  const ref = useRef<HTMLSpanElement | null>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const reduceMotion = useReducedMotion();
  const [display, setDisplay] = useState(reduceMotion ? value : 0);
  useEffect(() => {
    if (!inView || reduceMotion) {
      if (reduceMotion) setDisplay(value);
      return;
    }
    let frame = 0;
    const duration = 1100;
    const start = performance.now();
    const tick = (now: number) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(value * eased);
      if (progress < 1) frame = window.requestAnimationFrame(tick);
    };
    frame = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(frame);
  }, [inView, reduceMotion, value]);
  const formatted = decimals > 0 ? display.toFixed(decimals) : Math.round(display).toLocaleString('en-US');
  return <span ref={ref} data-id="element-234" data-mp="15qtzxqvu7a3i">
      {prefix}
      {formatted}
      {suffix}
    </span>;
}